import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "./styles/index.css";
import { appRoutes } from "./routes/routes.jsx";
import { queryClient } from "./utils/queryClient.js";
import {
  installGlobalEventListeners,
  installGlobalRevisitTracking,
} from "./utils/userActivityTracker";

installGlobalEventListeners();
installGlobalRevisitTracking();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={appRoutes()} />
    </QueryClientProvider>
  </StrictMode>,
);
